import { render } from "./trader-drawdown.vue?vue&type=template&id=5e166d2e"
import script from "./trader-drawdown.vue?vue&type=script&lang=js"
export * from "./trader-drawdown.vue?vue&type=script&lang=js"

import "./trader-drawdown.vue?vue&type=style&index=0&id=5e166d2e&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__